import { Link } from "react-router-dom";
import { ShieldCheck, Phone } from "lucide-react";
import { SITE_NAME, PREVENTION_TEXT } from "../../config/site";

const COLS = [
  {
    title: "Comprendre",
    links: [
      { label: "Qu'est-ce qu'un pari sportif ?", to: "/comprendre/quest-ce-quun-pari-sportif" },
      { label: "Les cotes", to: "/comprendre/les-cotes" },
      { label: "Les types de paris", to: "/comprendre/les-types-de-paris" },
      { label: "Les combinés", to: "/combines" },
      { label: "Glossaire", to: "/comprendre/glossaire" },
      { label: "Erreurs et mythes", to: "/comprendre/erreurs-et-mythes" },
      { label: "Les maths du long terme", to: "/comprendre/les-maths-du-long-terme" },
    ],
  },
  {
    title: "Cadre légal",
    links: [
      { label: "L'ANJ", to: "/cadre-legal/anj" },
      { label: "Site légal ou illégal ?", to: "/cadre-legal/site-legal-ou-illegal" },
      { label: "Les règles du joueur", to: "/cadre-legal/regles-du-joueur" },
      { label: "Fiscalité des gains", to: "/cadre-legal/fiscalite-des-gains" },
    ],
  },
  {
    title: "Comment ça fonctionne",
    links: [
      { label: "S'inscrire pas à pas", to: "/demarrer/sinscrire-pas-a-pas" },
      { label: "Dépôts et retraits", to: "/demarrer/depots-et-retraits" },
      { label: "Bonus de bienvenue", to: "/demarrer/bonus-de-bienvenue" },
      { label: "Jeu responsable", to: "/jeu-responsable" },
    ],
  },
  {
    title: "Le site",
    links: [
      { label: "À propos", to: "/a-propos" },
      { label: "Contact", to: "/contact" },
      { label: "Mentions légales", to: "/mentions-legales" },
      { label: "Confidentialité", to: "/confidentialite" },
      { label: "Cookies", to: "/cookies" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-[#0B1F3A] text-white" data-testid="site-footer">
      <div className="mx-auto max-w-6xl px-4 pb-28 pt-12 sm:px-6">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-5">
          <div>
            <div className="mb-3 flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-[#2BB08A]">
                <ShieldCheck className="h-4.5 w-4.5 text-white" aria-hidden="true" />
              </span>
              <span className="font-display text-base font-semibold">
                {SITE_NAME}
                <span className="text-[#2BB08A]">.fr</span>
              </span>
            </div>
            <p className="text-sm leading-relaxed text-white/70">
              Guide indépendant et pédagogique pour comprendre les paris sportifs en France.
              Aucune affiliation, aucun pronostic, aucune incitation à jouer.
            </p>
            <p className="mt-4 inline-flex items-center gap-1.5 rounded-full border border-[#E8A317] px-3 py-1 text-xs font-semibold text-[#E8A317]">
              18+ Réservé aux majeurs
            </p>
          </div>
          {COLS.map((col) => (
            <nav key={col.title} aria-label={col.title}>
              <h2 className="mb-3 font-display text-sm font-semibold uppercase tracking-wider text-[#2BB08A]">
                {col.title}
              </h2>
              <ul className="space-y-2">
                {col.links.map((l) => (
                  <li key={l.to + l.label}>
                    <Link
                      to={l.to}
                      className="text-sm text-white/75 transition-colors hover:text-white"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-10 border-t border-white/10 pt-6">
          <p className="flex flex-wrap items-center gap-2 text-sm font-medium text-[#E8A317]">
            <Phone className="h-4 w-4" aria-hidden="true" />
            {PREVENTION_TEXT}
          </p>
          <p className="mt-3 text-xs text-white/50">
            © {new Date().getFullYear()} {SITE_NAME} — Site pédagogique indépendant. Aucun pari,
            aucune inscription à un opérateur, aucun contenu commercial.{" "}
            <button
              type="button"
              data-testid="footer-cookie-settings"
              onClick={() => window.dispatchEvent(new Event("open-cookie-settings"))}
              className="underline transition-colors hover:text-white"
            >
              Gérer mes cookies
            </button>
          </p>
        </div>
      </div>
    </footer>
  );
}
